import { styled, Typography } from '@mui/material'
import { BackButton } from '$common/buttons'
import { goBackInProfilePanel } from '$logic/router'
import { t } from '$i18n'

export function MyAccountAppBar() {
  return (
    <Root>
      <TitleBackWrapper>
        <BackButton onClick={goBackInProfilePanel} color="neutral000" />
        <Typography color="neutral000" variant="h3">
          {t('myAccount.account')}
        </Typography>
      </TitleBackWrapper>
    </Root>
  )
}

const Root = styled('div')`
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.primary700};
  height: 56px;
`

const TitleBackWrapper = styled('div')`
  display: flex;
  align-items: center;
`
